/**
 * Zoho Books SDK early initializer.
 * Injects the ZFAPPS SDK script and calls extension.init() in the onload callback.
 * The resolved App object is stored on window.booksSDKApp for the module to consume.
 *
 * This mirrors zoho-desk/init.ts — the SDK must be initialized eagerly (before the
 * module's onInit runs) because ZFAPPS.extension.init() only works reliably when
 * called during the initial page load, not later during async module initialization.
 */

export function initZohoBooks() {
  const script = document.createElement('script');
  script.src = 'https://js.zohostatic.com/zohofinance/v1/zf_sdk.js';
  script.async = true;

  script.onload = () => {
    if ((window as any).ZFAPPS && (window as any).ZFAPPS.extension) {
      (window as any).ZFAPPS.extension.init().then(async (app: any) => {
        console.log('[ZohoBooks SDK] App initialized:', app.location);
        (window as any).booksSDKApp = app;
      }).catch((err: any) => {
        console.error('[ZohoBooks SDK] extension.init() failed:', err);
      });
    }
  };

  document.head.appendChild(script);
}
